export const categories = [
  {
    slug: 'zui-xin-dong-tai',
    name: '最新动态',
    icon: 'ri-flashlight-line',
    description: '蜜芽平台最新公告、版本更新与服务调整通知',
  },
  {
    slug: 'ke-fu-zhi-nan',
    name: '客服指南',
    icon: 'ri-customer-service-2-line',
    description: '联系蜜芽客服的各类方式与操作指引',
  },
  {
    slug: 'ding-dan-cha-xun',
    name: '订单查询',
    icon: 'ri-file-search-line',
    description: '订单物流追踪、退换货流程与售后处理指南',
  },
  {
    slug: 'she-qun-dong-tai',
    name: '社群动态',
    icon: 'ri-group-line',
    description: '蜜芽官方社群渠道、用户交流与活动信息',
  },
  {
    slug: 'cu-xiao-huo-dong',
    name: '促销活动',
    icon: 'ri-gift-line',
    description: '最新促销优惠、会员福利与限时活动资讯',
  },
];

export const getCategoryBySlug = (slug: string) => categories.find((c) => c.slug === slug);